
import InputNumber from 'primevue/inputnumber'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import {
  getCurrentInstance,
  onMounted,
  ref,
  toRefs
} from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'

export default {
  components: {
    Dialog,
    InputNumber,
    Button
  },
  props: {
    trxId: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    ritId: {
      type: String,
      default: ''
    },
    dieselExpenseDetailList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['hideDialogFuelingTransactionRevision', 'reloadData'],
  setup(props: any, { emit }: any) {
    const app = getCurrentInstance()
    const {
      $toast
    } = app?.appContext.config.globalProperties || {}
    const store = useStore()
    const router = useRouter()
    const isLoading = ref(true)
    const { show, trxId, dieselExpenseDetailList } = toRefs(props)
    const showModal = show.value
    const TrxId = trxId.value
    const solarBonEditData = ref([]) as any

    const endpointFuelingTransactionRevision = '/transaction/v2/FuelingTransactions'

    const getDetail = () => {
      store.dispatch('showLoading')

      if (dieselExpenseDetailList.value && dieselExpenseDetailList.value.length > 0) {
        const mappedData = dieselExpenseDetailList.value.map((item: any) => ({
          fuelingTransactionId: item.Id,
          fuelStationPartnerId: item.FuelStationPartnerId,
          fuelType: item.FuelType,
          fuelStationPartnerName: item.FuelStationPartnerName,
          oldLiters: item.Liters || 0,
          oldPrice: item.Price || 0,
          newLiters: item.Liters || 0,
          newPrice: item.Price || 0,
          unitPrice: 0
        }))

        const fetchPromises = mappedData.map(async (mappedItem: any) => {
          if (mappedItem.oldLiters === 0 && mappedItem.fuelStationPartnerId) {
            try {
              const res = await apiUseCase.get(`/management/v2/FuelStationPartners/${mappedItem.fuelStationPartnerId}`)
              if (!res.error && res.result && res.result.Stocks) {
                const stock = res.result.Stocks.find((s: any) => s.Name === mappedItem.fuelType)
                if (stock && stock.Price > 0) {
                  mappedItem.unitPrice = stock.Price
                }
              }
            } catch (e) {
              console.error(e)
            }
          } else if (mappedItem.oldLiters > 0 && mappedItem.oldPrice > 0) {
            mappedItem.unitPrice = mappedItem.oldPrice / mappedItem.oldLiters
          }
          return mappedItem
        })

        Promise.all(fetchPromises).then((results) => {
          solarBonEditData.value = results
          isLoading.value = false
          store.dispatch('hideLoading')
        }).catch(() => {
          solarBonEditData.value = mappedData
          isLoading.value = false
          store.dispatch('hideLoading')
        })
      } else {
        isLoading.value = false
        store.dispatch('hideLoading')
      }
    }

    const navigateToFuelingDetail = (fuelingTransactionId: string) => {
      const encryptedId = encryptDecriptMethods.encrypt(fuelingTransactionId)
      router.push({
        name: 'approve-deposits-fueling-detail',
        params: { id: encryptedId }
      })
    }

    const closeDialog = () => {
      emit('hideDialogFuelingTransactionRevision')
    }

    const onSubmit = async () => {
      store.dispatch('showLoading')
      try {
        const solarBonPromises = solarBonEditData.value
          .filter((item: any) => item.oldPrice !== item.newPrice)
          .map((item: any) => {
            const payload = {
              FuelingTransactionId: item.fuelingTransactionId,
              OldLiters: item.oldLiters,
              OldPrice: item.oldPrice,
              NewPrice: item.newPrice,
              EvidenceImageUrl: null
            }
            return apiUseCase.postWithNoId(`${endpointFuelingTransactionRevision}/${item.fuelingTransactionId}/FuelingTransactionRevisions`, payload)
          })

        if (solarBonPromises.length > 0) {
          const results = await Promise.all(solarBonPromises)
          const errors = results.filter((r: any) => r.error)
          if (errors.length > 0) {
            throw new Error('Beberapa data transaksi BBM gagal disimpan')
          }
        } else {
          $toast.add({
            severity: 'info',
            detail: 'Tidak ada perubahan pada data Solar Bon',
            group: 'bc',
            closable: false,
            life: 3000
          })
          store.dispatch('hideLoading')
          closeDialog()
          return
        }

        $toast.add({
          severity: 'success',
          detail: 'Berhasil menyimpan pengeluaran Solar Bon',
          group: 'bc',
          closable: false,
          life: 3000
        })
        store.dispatch('setReloadDataList')
        emit('reloadData')
        closeDialog()
      } catch (err: any) {
        $toast.add({
          severity: 'error',
          detail: err.message || 'Terjadi kesalahan saat menyimpan',
          group: 'bc',
          closable: false,
          life: 3000
        })
      } finally {
        store.dispatch('hideLoading')
      }
    }

    const onSolarBonPriceInput = (event: any, item: any) => {
      const newPrice = event.value
      item.newPrice = newPrice
      if (newPrice !== null && newPrice !== undefined && newPrice > 0) {
        if (item.unitPrice && item.unitPrice > 0) {
          const calculatedLiters = Number(newPrice) / item.unitPrice
          item.newLiters = Number(calculatedLiters.toFixed(2))
        } else if (item.oldPrice && item.oldPrice > 0) {
          const calculatedLiters = (item.oldLiters * Number(newPrice)) / item.oldPrice
          item.newLiters = Number(calculatedLiters.toFixed(2))
        } else {
          item.newLiters = 0
        }
      } else {
        item.newLiters = 0
      }
    }

    onMounted(() => {
      getDetail()
    })

    return {
      isLoading,
      showModal,
      closeDialog,
      onSubmit,
      TrxId,
      solarBonEditData,
      navigateToFuelingDetail,
      onSolarBonPriceInput
    }
  }
}
